import { Asset } from 'app-lib/assetUtils'
import { DEX } from 'app-lib/dexSelector/types'
import { BigNumber } from '@0x/utils'
import { ChainId } from '../config/chains/chainCommon'
import IBorrowedFundsState from './IBorrowedFundsState'

export enum PositionType {
  LONG = 'LONG',
  SHORT = 'SHORT',
}

export enum TradeType {
  OPEN_POSITION = 'OPEN_POSITION',
  CLOSE_POSITION = 'CLOSE_POSITION',
}

/**
 *
 * * `loanDataBytes` {string} Must be set to '0x' if not needed
 * * `amount` {BigNumber} Is the amount the user would use as collateral
 */
export interface ITradeRequest {
  /** Amount without leverage */
  amount: BigNumber
  baseToken: Asset
  depositToken: Asset
  dex: DEX
  leverage: number
  loanDataBytes: string
  loanId?: string
  positionType: PositionType
  quoteToken: Asset
  returnTokenIsCollateral: boolean
  tradeType: TradeType
  positionValue?: number
}

export interface IClosePositionRequest extends ITradeRequest {
  loanId: string
  returnTokenIsCollateral: boolean
  tradeType: TradeType.CLOSE_POSITION
}

export interface IOpenPositionProps {
  chainId: ChainId
  activeTokenLiquidation: Asset
  activeTokenProfit: Asset
  baseToken: Asset
  collateral: BigNumber
  currentPrice: BigNumber
  isLoading: boolean
  leverage: number
  liquidationPrice: BigNumber
  loan: IBorrowedFundsState
  loanApr: BigNumber
  maintenanceMargin: BigNumber
  openPrice: BigNumber
  pendingTx: boolean
  positionType: PositionType
  positionValue: BigNumber
  profitCollateralToken: BigNumber
  profitLoanToken: BigNumber
  profitUSD: BigNumber
  quoteToken: Asset
  value: BigNumber
  valueChange: BigNumber
}

export interface IPendingPosition {
  baseToken: Asset
  quoteToken: Asset
  positionType: PositionType
  leverage: number
  positionValue: number
  time: number
}
